var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    width: 31,
    height: 31,
    rx: 15.104,
    transform: "rotate(90 31 0)",
    fill: "#0F55AB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    width: 31,
    height: 31,
    rx: 15.104,
    transform: "rotate(90 31 0)",
    stroke: "#EFF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10352 11.5986L20.8171 11.5986M17.4704 14.9453L20.8171 11.5986L17.4704 8.25183",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8965 18.9848L9.18288 18.9848M12.5296 22.3315L9.18288 18.9848L12.5296 15.6381",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInOut);
export default __webpack_public_path__ + "static/media/InOut.fd014aae6dec8fdcf1fc9d4bff17f82f.svg";
export { ForwardRef as ReactComponent };